const enum StageNames {
    OCR = "OCR",
    DATA_NORMALIZATION = "Data Normalization",
    ENTITY_DETECTION = "Entity Detection",
    TABLE_ANALYSIS = "Table Analysis",
    CROSS_TABLE_ANALYSIS = "Cross Table Analysis",
    SUMMARY = "Summary",
}

export {StageNames}